import React, { Fragment } from 'react';
import {Theme} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { alpha } from '@mui/material/styles';
import classnames from 'classnames';
import './loader.scss';

const useStyles = makeStyles()((theme: Theme) =>
    {
        return {
            root: {
                backgroundColor: alpha(theme.palette.common.black, 0.5),
                position: 'absolute',
                height: '100%',
                width: '100%',
                zIndex: 1,
            },
            spinner: {
                border: `${'5px ' + 'solid '}${theme.palette.secondary.dark}`,
                borderTop: `${'5px ' + 'solid '}${alpha(theme.palette.common.black, 0)}`,
            },
            spinnerWrapper: {
                zIndex: 8,
                position: 'absolute',
                top: '30%',
                // left: 0;
                right: '30%',
            },
        }
    }
);
export default function Loader(): React.ReactElement {
    const { classes } = useStyles();
    return (
        <Fragment>
            <div className={classes.root}></div>
            <div className={classes.spinnerWrapper}>
                <LoadingSpinner />
            </div>
        </Fragment>
    );
}

export function LoadingSpinner(): React.ReactElement {
    const { classes } = useStyles();
    const loadingClass = classnames(classes.spinner, 'loadingscreen_spinner');
    return <div className={loadingClass}></div>;
}
